import { registerQuery, useQuery } from 'data-fetching-client';
//@ts-expect-error untyped-file
import { resolveAttachmentsClient } from '../clients/resolveAttachmentsClient';
export const RESOLVE_ATTACHMENTS_QUERY = registerQuery({
  fieldName: 'resolveAttachments',
  args: ['sessionId', 'threadId', 'fileIds'],
  fetcher: resolveAttachmentsClient
});
export function useResolveAttachments({
  sessionId,
  threadId,
  fileIds
}) {
  return useQuery(RESOLVE_ATTACHMENTS_QUERY, {
    variables: {
      sessionId,
      threadId,
      fileIds
    }
  });
}